(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-hero"] && !Shopify.designMode) return;
  try {
    
  /* DD · Hero — el corte móvil se sirve solo donde de verdad calza, y eso pide DOS condiciones.
     Hacen falta las dos; ninguna sola alcanza (medido, no supuesto):

     1) El breakpoint de 900px, que es donde esta sección cambia de layout. Arriba de 900px el
        media deja de ser una banda ancha y se vuelve una columna a sangre de 52-56vw por el
        alto completo del hero: a 1440px la caja mide 749x975, o sea r=0.77 — MÁS vertical que
        la de un teléfono. Filtrar solo por proporción le serviría el archivo de 720px a
        escritorio, donde la caja mide 749 CSS px (1498 físicos en DPR 2) y se vería suave.

     2) La proporción de la caja, porque debajo de 900px la forma todavía cambia mucho:
        .dd-hero__frame es 100vw x clamp(340px, 54vh, 520px), así que da r~0.83-0.86 en teléfono
        vertical (el corte calza), pero r~1.43-1.48 en iPad y foldable abierto y r~2.48 en
        teléfono horizontal. Ahí el corte saldría con zoom de 43-66%. Un breakpoint solo no los
        distingue: los tres caen dentro de los 900px.

     Umbral 0.95: pasando de ahí `cover` empieza a comerse el borde inferior del corte, que es
     justo donde está el disco. Sin caja con layout → Infinity → cae al video de escritorio,
     que es el lado seguro. Orden de la lista = failover nativo del navegador: solo baja el
     siguiente si el anterior falla (429/404/5xx), nunca los dos. */
  (function () {
  /* Con movimiento reducido no se arma el video: queda el póster (igual que dd-home.js en main). */
  function arm(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
    var videos = root.querySelectorAll('.dd-hero__video');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      if (v.querySelector('source')) { continue; }

      var frame = v.closest('.dd-hero__frame');
      var ratio = Infinity;
      if (frame && frame.clientHeight > 0) { ratio = frame.clientWidth / frame.clientHeight; }
      var narrow = window.matchMedia('(max-width: 900px)').matches;

      var list = [];
      var mobile = v.getAttribute('data-src-mobile');
      if (mobile && narrow && ratio <= 0.95) { list.push(mobile); }
      if (v.getAttribute('data-src')) { list.push(v.getAttribute('data-src')); }
      if (v.getAttribute('data-src-fallback')) { list.push(v.getAttribute('data-src-fallback')); }
      if (!list.length) { continue; }

      for (var j = 0; j < list.length; j++) {
        var source = document.createElement('source');
        source.src = list[j];
        source.type = 'video/mp4';
        v.appendChild(source);
      }
      /* Solo load(): reanuda la selección de recurso ahora que sí hay <source>, y deja
         intacta la bandera can-autoplay, así que el atributo autoplay nativo hace su
         trabajo. NO llamar play(): en una pestaña en segundo plano Chrome lo rechaza
         ("video-only background media was paused to save power") y, por haberse invocado,
         el autoplay nativo ya no lo retoma al volver a la pestaña — el hero se queda
         congelado en el frame 0. Medido: con play() paused=true; sin él, reproduce. */
      v.load();
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { arm(document); }); } else { arm(document); }
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();
  /* DD · Octubre 2026 — el comercial con sonido en un <dialog> nativo. El mp4 solo se pide al abrir. */
  (function () {
    function bind(root) {
      root.querySelectorAll('[data-dd-commercial-open]').forEach(function (btn) {
        if (btn.dataset.ddBound) return;
        btn.dataset.ddBound = '1';
        var dlg = document.getElementById(btn.getAttribute('aria-controls'));
        if (!dlg || typeof dlg.showModal !== 'function') return;
        var video = dlg.querySelector('video');
        var close = function () { if (video) video.pause(); if (dlg.open) dlg.close(); };
        btn.addEventListener('click', function () {
          if (video && !video.getAttribute('src')) video.setAttribute('src', video.dataset.src);
          dlg.showModal();
          if (video) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        });
        dlg.querySelector('[data-dd-commercial-close]').addEventListener('click', close);
        dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
        dlg.addEventListener('close', function () { if (video) video.pause(); btn.focus(); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); }); else bind(document);
    document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-season"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dd-season-path')) {
    customElements.define('dd-season-path', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dd-season__track');
        this.steps = Array.from(this.querySelectorAll('.dd-season__step'));
        if (!this.track || this.steps.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.auto = this.dataset.autoplay !== 'false';
        this.i = -1;
        this.classList.add('is-anim');

        this.steps.forEach((step, k) => {
          const pin = step.querySelector('.dd-season__pin');
          if (pin) {
            pin.removeAttribute('tabindex');
            pin.addEventListener('click', () => { this.stop(); this.go(k, true); });
          }
          step.addEventListener('click', (e) => {
            if (!e.target.closest('.dd-season__pin') && window.matchMedia('(max-width: 749px)').matches) return;
            this.stop(); this.go(k, true);
          });
          step.addEventListener('mouseenter', () => {
            if (window.matchMedia('(hover: hover) and (min-width: 750px)').matches) { this.stop(); this.go(k, true); }
          });
        });

        this.onResize = () => { if (this.i >= 0) this.place(this.i, false); };
        window.addEventListener('resize', this.onResize, { passive: true });

        if (!this.auto) { this.go(this.steps.length - 1, true); return; }
        this.reset();
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.intersectionRatio >= 0.45 && !this.played) this.play();
            else if (!e.isIntersecting && this.played) { this.played = false; this.stop(); this.reset(); }
          });
        }, { threshold: [0, 0.45] });
        this.io.observe(this.track);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        this.stop();
        window.removeEventListener('resize', this.onResize);
      }

      place(k, animate) {
        const pin = this.steps[k].querySelector('.dd-season__pin');
        const first = this.steps[0].querySelector('.dd-season__pin');
        if (!pin || !first) return;
        const t = this.track.getBoundingClientRect();
        const center = (el) => { const r = el.getBoundingClientRect(); return r.left + r.width / 2 - t.left; };
        if (!animate) this.track.classList.add('no-tr');
        this.track.style.setProperty('--x0', center(first) + 'px');
        this.track.style.setProperty('--x', center(pin) + 'px');
        if (!animate) { void this.track.offsetWidth; this.track.classList.remove('no-tr'); }
      }

      go(k, instant) {
        this.i = k;
        clearTimeout(this.litTimer);
        this.steps.forEach((s, j) => {
          s.classList.toggle('is-current', j === k);
          if (j > k) s.classList.remove('is-lit');
        });
        this.place(k, !instant);
        const light = () => this.steps.forEach((s, j) => s.classList.toggle('is-lit', j <= k));
        if (instant) light();
        else this.litTimer = setTimeout(light, k === 0 ? 150 : 900);
      }

      play() {
        this.played = true;
        this.stop();
        this.reset();
        const next = () => {
          if (this.i + 1 >= this.steps.length) return;
          this.go(this.i + 1);
          this.timer = setTimeout(next, 1300);
        };
        this.timer = setTimeout(next, 300);
      }

      stop() { clearTimeout(this.timer); }

      reset() {
        clearTimeout(this.litTimer);
        this.i = -1;
        this.steps.forEach((s, j) => { s.classList.remove('is-lit'); s.classList.toggle('is-current', j === 0); });
        this.place(0, false);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-vip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-dd-vip]').forEach(function (sec) {
        var form = sec.querySelector('form');
        if (!form || form.dataset.ddVipReady) return;
        form.dataset.ddVipReady = '1';
        var tags = form.querySelector('[data-dd-vip-tags]');
        var base = tags ? tags.value : '';
        form.addEventListener('change', function (e) {
          if (!tags || !e.target.closest('.dd-cap__chip')) return;
          var picked = Array.prototype.map.call(form.querySelectorAll('.dd-cap__chip input:checked'), function (i) { return i.value; });
          tags.value = picked.length ? base + ', ' + picked.join(', ') : base;
        });
        if (sec.classList.contains('dd-cap--page') && /[?&]vip=bf26\b/.test(location.search)) {
          var done = sec.querySelector('[data-dd-vip-done]');
          var fields = sec.querySelector('[data-dd-vip-fields]');
          if (done) done.hidden = false;
          if (fields) fields.hidden = true;
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
